import styled from 'styled-components';
import CancelSubmitSvg from '../../assets/mytrips/cancel-submit.svg';

const CancelSubmitIcon = styled(CancelSubmitSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '21rem'};
  height: ${props => props.height || '11.5rem'};
  margin: ${props => props.margin};
`;

export default CancelSubmitIcon;
